import { withInstall } from "../utils/index.mjs";
import _Slider from "./Slider.mjs";
const Slider = withInstall(_Slider);
var stdin_default = Slider;
import { sliderProps } from "./Slider.mjs";
export {
  Slider,
  stdin_default as default,
  sliderProps
};
